import React from "react";
import CommonToast from "./CommonToast";
import "../../assets/css/CommonToast.css";

export default function CommonToastContainer({ toasts, removeToast }) {
    return (
        <div className="toast-container">
            {toasts.map((toast) => (
                <CommonToast
                    key={toast.id}
                    {...toast}
                    onClose={() => removeToast(toast.id)}
                />
            ))}
        </div>
    );
}
